import { render, staticRenderFns } from "./termBank.vue?vue&type=template&id=00ae0671&scoped=true&"
import script from "./termBank.vue?vue&type=script&lang=js&"
export * from "./termBank.vue?vue&type=script&lang=js&"
import style0 from "./termBank.vue?vue&type=style&index=0&id=00ae0671&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ae0671",
  null
  
)

export default component.exports